<template>
  <div class="annual-investment-plan-container">
    <div class="plan-table-container">
      <div class="table-wrapper">
        <div class="table-scroll-area">
          <table class="investment-table">
            <thead>
              <tr>
                <th class="sequence-col" style="text-align: center">序号</th>
                <th class="project-col">项 目</th>
                <th class="total-col">合计</th>
                <th
                  v-for="year in sData.planData?.参数?.fullLoadYear || 0"
                  :key="year"
                  style="text-align: center"
                >
                  {{ year }}
                </th>
              </tr>
              <tr>
                <th class="sequence-col">-</th>
                <th class="project-col" style="text-align: center">
                  建设期/运营期
                </th>
                <th class="total-col">-</th>
                <th
                  class="year-col period-type-col construction-year"
                  :colspan="sData.planData?.参数?.constructionPeriod || 0"
                  style="text-align: center"
                >
                  建设期
                </th>
                <th
                  class="year-col period-type-col operating-year"
                  :colspan="
                    (sData.planData?.参数?.fullLoadYear || 0) -
                      (sData.planData?.参数?.constructionPeriod || 0) || 0
                  "
                  style="text-align: center"
                >
                  运营期
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- 总投资部分 -->
              <tr class="section-row main-section">
                <td style="text-align: center">1</td>
                <td class="section-title" style="text-align: left">总投资</td>
                <td class="amount-cell">
                  {{ formatNumber(sData.planData?.总投资?.amount || 0) }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || 0"
                  :key="`total-${index}`"
                >
                  {{
                    formatNumber(sData.planData?.总投资?.year?.[index - 1] || 0)
                  }}
                </td>
              </tr>

              <tr class="sub-section">
                <td style="text-align: center">1.1</td>
                <td style="text-align: left">建设投资</td>
                <td class="amount-cell">
                  {{
                    formatNumber(sData.planData?.总投资?.建设投资?.amount || 0)
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || 0"
                  :key="`total-construction-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.总投资?.建设投资?.year[index - 1] || 0,
                    )
                  }}
                </td>
              </tr>

              <tr class="sub-section">
                <td style="text-align: center">1.2</td>
                <td style="text-align: left">建设期利息</td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.总投资?.建设期利息?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`total-interest-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.总投资?.建设期利息?.year[index - 1] || 0,
                    )
                  }}
                </td>
              </tr>

              <tr class="sub-section">
                <td style="text-align: center">1.3</td>
                <td style="text-align: left">流动资金</td>
                <td class="amount-cell">
                  {{
                    formatNumber(sData.planData?.总投资?.流动资金?.amount || 0)
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`total-working-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.总投资?.流动资金?.year[index - 1] || 0,
                    )
                  }}
                </td>
              </tr>

              <!-- 资金筹措部分 -->
              <tr class="section-row main-section">
                <td style="text-align: center">2</td>
                <td class="section-title" style="text-align: left">资金筹措</td>
                <td class="amount-cell">
                  {{ formatNumber(sData.planData?.资金筹措?.amount || 0) }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`financing-${index}`"
                >
                  {{ formatNumber(sData.planData?.资金筹措?.year[index - 1]) }}
                </td>
              </tr>

              <!-- 资本金部分 -->
              <tr class="sub-section">
                <td style="text-align: center">2.1</td>
                <td style="text-align: left">资本金（项目资本金）</td>
                <td class="amount-cell">
                  {{
                    formatNumber(sData.planData?.资金筹措?.资本金?.amount || 0)
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`capital-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.year[index - 1] || 0,
                    )
                  }}
                </td>
              </tr>

              <!-- 资本金明细 -->
              <tr class="detail-row">
                <td></td>
                <td class="detail-title" style="text-align: left">
                  其中：用于建设投资
                </td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.建设投资?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`capital-construction-${index}`"
                  :style="
                    index < (sData.planData?.参数?.constructionPeriod || 0)
                      ? {
                          'background-color': '#409EFF',
                          color: '#fff',
                        }
                      : {}
                  "
                >
                  <input
                    v-if="
                      index < (sData.planData?.参数?.constructionPeriod || 0)
                    "
                    type="number"
                    :value="
                      sData.planData?.资金筹措?.资本金?.建设投资?.year[
                        index - 1
                      ]?.toFixed(2)
                    "
                    @input="
                      (e) => {
                        const value = parseFloat(e.target.value) || 0;
                        const formattedValue = Math.round(value * 100) / 100;
                        sData.planData.资金筹措.资本金.建设投资.year[
                          index - 1
                        ] = formattedValue;
                      }
                    "
                    @change="handleInput(index - 1)"
                    step="0.01"
                    min="0"
                    style="
                      width: 100%;
                      text-align: right;
                      border: none;
                      outline: none;
                      background: #409eff;
                      font-family: inherit;
                      color: #fff;
                    "
                  />
                  <span v-else>{{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.建设投资?.year[
                        index - 1
                      ] || 0,
                    )
                  }}</span>
                </td>
              </tr>

              <tr class="detail-row">
                <td></td>
                <td class="detail-title" style="text-align: left">
                  建设期利息
                </td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.建设期利息?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`capital-interest-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.建设期利息?.year[
                        index - 1
                      ] || 0,
                    )
                  }}
                </td>
              </tr>

              <tr class="detail-row">
                <td></td>
                <td class="detail-title" style="text-align: left">
                  用于流动资金
                </td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.流动资金?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`capital-working-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.资本金?.流动资金?.year[
                        index - 1
                      ] || 0,
                    )
                  }}
                </td>
              </tr>

              <!-- 债务资金部分 -->
              <tr class="sub-section">
                <td style="text-align: center">2.2</td>
                <td style="text-align: left">债务资金（银行借款等）</td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.债务资金?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`debt-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.债务资金?.year[index - 1] || 0,
                    )
                  }}
                </td>
              </tr>

              <!-- 债务资金明细 -->
              <tr class="detail-row">
                <td></td>
                <td class="detail-title" style="text-align: left">
                  用于建设投资
                </td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.债务资金?.建设投资?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`debt-construction-${index}`"
                >
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.债务资金?.建设投资?.year[
                        index - 1
                      ] || 0,
                    )
                  }}
                </td>
              </tr>

              <tr class="detail-row">
                <td></td>
                <td class="detail-title" style="text-align: left">
                  用于流动资金
                </td>
                <td class="amount-cell">
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.债务资金?.流动资金?.amount || 0,
                    )
                  }}
                </td>
                <td
                  v-for="index in sData.planData?.参数?.fullLoadYear || []"
                  :key="`debt-working-${index}`"
                  :class="['input-cell']"
                >
                  {{
                    formatNumber(
                      sData.planData?.资金筹措?.债务资金?.流动资金?.year[
                        index - 1
                      ] || 0,
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calculateAnnualInvestment } from "@/utils/comp.js";
export default {
  name: "AnnualInvestmentPlan",
  props: {
    isViewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sData: {},
      projectData: {},
      old: {},
      investmentData: {},
      constructionPeriod: 3,
      operatingPeriod: 15,
      totalYears: 18,
      loadData: {},
      fullLoadYear: null,
      // 输入区域数据
      workingCapitalCapitalUsageRate: 30,
      totalInvestmentAllocationMethod: "average",
      totalInvestmentInputs: Array(3).fill(0),
      capitalAllocationMethod: "average",
      capitalInputs: Array(3).fill(0),
    };
  },

  computed: {
    // 获取需要显示的年份（从第1年到100%负荷年）
    displayYears() {
      // 如果有100%负荷年，则显示到该年
      if (this.fullLoadYear) {
        return Array.from({ length: this.fullLoadYear }, (_, i) => i + 1);
      }
      // 如果没有100%负荷年，则显示所有年份
      return Array.from({ length: this.totalYears }, (_, i) => i + 1);
    },
  },

  created() {
    this.sData = {
      planData: {},
    };

    this.sData.planData =
      this.$store.state.projectData.资金筹措及分年投资计划.分年投资计划 || {};
    this.propsData = this.$store.state.projectData;

    // this.$store.commit(
    //   "setplanamount",
    //   this.propsData.资金筹措及分年投资计划?.总投资?.分年投资计划?.amount || 0
    // );

    console.log("传过来的：", this.sData);

    // 初始化输入数据
    // this.initializeInputData();
  },

  methods: {
    // 格式化数字显示（保留两位小数）
    formatNumber(num) {
      if (num === null || num === undefined || num === "") {
        return "";
      }
      const value = Number(num);
      if (isNaN(value) || value === 0) {
        return "";
      }
      return value.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    // 格式化输入框显示的值（保留两位小数）
    formatInputNumber(num) {
      if (num === null || num === undefined || num === "") {
        return "";
      }
      const value = Number(num);
      if (isNaN(value)) {
        return "";
      }
      return Math.round(value * 100) / 100;
    },

    // 更新输入框值
    handleInput(index) {
      let i = Number(index);

      // 在计算前保存当前值，以便在出错时可以恢复
      const originalValue =
        this.sData.planData.资金筹措.资本金.建设投资.year[i];
      this.propsData.资金筹措及分年投资计划.分年投资计划 = this.sData.planData;

      this.$store.commit("SET_PROJECT_DATA", this.propsData);

      // let s = calculateAnnualInvestment(`${i}`);
      let s = calculateAnnualInvestment(`${i}`);

      // console.log("返回值：", s);

      if (s && s.code === 400) {
        this.$message({
          message: s.msg,
          type: "error",
        });

        // 立即恢复原始值
        this.$set(
          this.sData.planData.资金筹措.资本金.建设投资.year,
          i,
          originalValue,
        );

        // 使用 nextTick 确保 DOM 更新
        this.$nextTick(() => {
          this.$forceUpdate();
        });

        return;
      } else if (s) {
        this.sData = s;
        this.$store.commit(
          "setplanamount",
          this.propsData.资金筹措及分年投资计划?.总投资?.分年投资计划?.amount ||
            0,
        );
        this.old = s;
      }
    },
  },
};
</script>

<style scoped>
.annual-investment-plan-container {
  padding: 10px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.header-controls button {
  margin-left: 10px;
}

.plan-table-container {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  height: 500px;
  overflow: auto;
}

.table-wrapper {
  position: relative;
  width: 100%;
}

.table-scroll-area {
  overflow: visible;
}

.investment-table {
  font-size: 12px;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.investment-table th,
.investment-table td {
  border: 1px solid #e5e5e5;
  padding: 8px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.investment-table th {
  background-color: #f5f7fa;
  font-weight: bold;
}

.sequence-col {
  width: 60px;
}

.project-col {
  width: 200px;
}

.total-col {
  width: 120px;
}

.year-col {
  width: 80px;
  text-align: center;
}

.amount-cell {
  text-align: right;
  font-weight: 500;
}

.section-row {
  background-color: #f9fafc;
}

.main-section {
  font-weight: bold;
}

.sub-section {
  background-color: #f5f7fa;
}

.detail-row {
  background-color: #fcfcfc;
}

.detail-title {
  padding-left: 20px;
  font-style: italic;
}

.section-title {
  font-weight: bold;
}

.construction-period {
  background-color: #e6f7ff;
}

.operating-period {
  background-color: #f6ffed;
}

.period-type-col {
  text-align: center;
  font-weight: bold;
  color: #333;
}

.construction-year {
  background-color: #91d5ff;
}

.operating-year {
  background-color: #b7eb8f;
}

.year-input {
  width: 100%;
  border: 1px solid #ddd;
  background-color: #fffacd;
  text-align: center;
  font-size: 10px;
  outline: none;
  border-radius: 2px;
  padding: 2px 4px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.year-input:focus {
  background-color: #fff8dc;
  border-color: #ffa500;
  box-shadow: 0 0 5px rgba(255, 165, 0, 0.3);
}

.year-input:hover {
  background-color: #fff8dc;
  border-color: #ffa500;
}

/* 输入区域样式 */
.input-section {
  background-color: #f9f9f9;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
}

.input-row {
  margin-bottom: 10px;
}

.compact-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  flex-wrap: wrap;
}

.input-title {
  font-weight: bold;
  font-size: 13px;
  color: #333;
  min-width: 140px;
  white-space: nowrap;
}

.input-inline {
  display: flex;
  align-items: center;
  gap: 5px;
}

.short-input {
  padding: 4px 8px;
  border-radius: 3px;
  border: 1px solid #ddd;
  width: 70px;
  font-size: 12px;
  text-align: right;
}

.select-inline {
  padding: 4px 8px;
  border-radius: 3px;
  border: 1px solid #ddd;
  background-color: white;
  font-size: 12px;
  min-width: 100px;
}

.year-inputs-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1;
}

.year-input-group {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px 6px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid #e5e5e5;
}

.year-label {
  font-size: 11px;
  color: #666;
  white-space: nowrap;
}

.year-input-group input {
  padding: 3px 4px;
  border-radius: 2px;
  border: 1px solid #ddd;
  width: 55px;
  font-size: 12px;
  text-align: right;
}

.unit {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.confirm-btn {
  padding: 4px 12px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.confirm-btn:hover {
  background-color: #0066cc;
}

.divider {
  height: 1px;
  background-color: #e5e5e5;
  margin: 10px 0;
  border: none;
  width: 100%;
}

.investment-table .input-cell {
  position: relative;
}

.investment-table .input-cell::before {
  content: "✎";
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 10px;
  color: #ffa500;
  opacity: 0.7;
}
</style>
